module.exports = __webpack_public_path__ + "static/cosypinkbunny-03379d6a5344ee940e3535bac3e835c8.jpeg";